// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6cc48eab","389":"4d2341bc","453":"a04ae9d0","455":"588c6a42"}[chunkId] + ".chunk.js";
};